var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('imgWithNoImageError',{class:'img-list-thumbnail',attrs:{"src":_vm.src,"height":"70px","width":"70px"}})}
var staticRenderFns = []

export { render, staticRenderFns }